'use client'
import { createContext, ReactNode } from 'react'

type ContextType = {
  onClose: () => void
  onResize: () => void
  semiOpened: boolean
  setSemiOpened: (isSemiOpened: boolean) => void
  setDrawerBody: (body: ReactNode) => void
  drawerBody: ReactNode | null
}
export const DrawerContext = createContext<ContextType>({
  semiOpened: true,
  onClose: () => {
    // no-op
  },
  onResize: () => {
    // no-op
  },
  setSemiOpened: () => {
    return
  },
  setDrawerBody: () => null,
  drawerBody: null,
})
